import React, { Component } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
export default class Filters extends Component {
    render() {
        const { toolTypes, toolType, setToolType } = this.props;
        return (
                    <div
                        style={{
                            float: "left"
                        }}
                    >
                        <FormControl style={{ minWidth: 200, marginLeft: 20 }}>
                            <InputLabel>Filter By Categories</InputLabel>
                            <Select
                                value={toolType}
                                onChange={event =>
                                    setToolType(event.target.value)
                                }
                            >
                                <MenuItem value="all_categories">
                                    All Categories
                                </MenuItem>
                                {toolTypes &&
                                    toolTypes.map(e => {
                                        return (
                                            <MenuItem value={e}>{e}</MenuItem>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                    </div>
        );
    }
}
